module.exports = __webpack_public_path__ + "static/img/znq1009.1c1884a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/znq1009.jpg
// module id = BxCD
// module chunks = 0